import { buildProps } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'
import type Row from './row.vue'

export const RowJustify = [
  'start',
  'center',
  'end',
  'space-around',
  'space-between',
  'space-evenly',
] as const

export const RowAlign = ['start', 'center', 'end'] as const

export const rowProps = buildProps({
  tag: {
    type: String,
    default: 'div',
  },
  gutter: {
    type: [Number, String],
    default: 6,
  },
  justify: {
    type: String,
    values: RowJustify,
    default: 'start',
  },
  items: {
    type: String,
    values: RowAlign,
    default: 'start',
  },
} as const)

export type RowProps = ExtractPropTypes<typeof rowProps>
export type RowInstance = InstanceType<typeof Row>
